module.exports = __webpack_public_path__ + "static/ruby-289c004c57e6f5fc8bafc22c24fe5072.svg";